var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import getJSONValue from '../utils/fields/getJSONValue';
import evaluateFunctionOrValue from '../utils/evaluateFunctionOrValue';
import { createSelector, createSelectorCreator, defaultMemoize } from 'reselect';
import { isEqual, mapValues } from 'lodash';
import { connect } from 'react-redux';
import { getLocalizedSharedData, getLocalizedAppData } from '../utils/getLocalizedUserText';
/**
 * Map shared and appData values into a widget's config
 */
export default function withMappedWidgetConfig(component) {
    return connect(function () {
        var selectResolvedAppDataPaths = createSelectorCreator(defaultMemoize, isEqual)(function (state, rawConfig, type, widgetId) {
            var appDataFieldPaths = state.widgetFactory.loadMetaData(type).appDataFieldPaths;
            if (!appDataFieldPaths) {
                return {};
            }
            return mapValues(appDataFieldPaths, function (path) { return evaluateFunctionOrValue(path, state, rawConfig, widgetId); });
        }, function (paths) { return paths; });
        var selectAppData = createSelector(selectResolvedAppDataPaths, function (state) { return state.appData; }, function (state) { return state.localizedUserText; }, function (appDataFieldPaths, appData, localizedUserText) { return mapValues(appDataFieldPaths, function (path) { return getLocalizedAppData({
            baseText: getJSONValue(appData, path),
            localizedUserText: localizedUserText,
            path: path
        }); }); });
        var selectSharedData = createSelector(function (state, type) { return state.website.siteInfo.sharedConfigs[type]; }, function (state, type) { return type; }, function (state) { return state.localizedUserText; }, function (baseText, type, localizedUserText) { return getLocalizedSharedData({
            baseText: baseText,
            localizedUserText: localizedUserText,
            widgetType: type
        }); });
        return createSelector(function (state, props) { return props.config; }, function (state, props) { return selectSharedData(state, props.type); }, function (state, props) { return selectAppData(state, props.config, props.type, props.id); }, function (rawConfig, shared, appData) {
            return {
                config: __assign(__assign({}, rawConfig), { shared: __assign(__assign({}, (rawConfig.shared || {})), shared), appData: appData })
            };
        });
    })(component);
}
